export enum CardsColumns {
	id = "Id",
	cardHolder = "Cardholder",
	last4Digits = "Last 4 Digits",
	accountId = "Account",
	expiration = "Expiration",
	status = "Status",
	cardType = "Type",
	createdAt = "Created At",
	updatedAt = "Updated At",
	org = "Org",
	bank = "Bank",
	actions = "Actions",
}

export type AllowedCardsColumns =
	| CardsColumns.id
	| CardsColumns.cardHolder
	| CardsColumns.last4Digits
	| CardsColumns.accountId
	| CardsColumns.expiration
	| CardsColumns.status
	| CardsColumns.cardType
	| CardsColumns.createdAt
	| CardsColumns.updatedAt
	| CardsColumns.org
	| CardsColumns.bank
	| CardsColumns.actions
